import React, { Component } from 'react';
import style from './index.module.css';
import Chapter10 from './chapter10';

class Chapter9 extends Component<any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      status,
      brandTotal,
      brandCityTotal,
      displayButton
    } = this.props.data;
    // if (status === 0) return null;
    const { setPoster } = this.props;

    return (
      <div
        className={style.pageBgType201}
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          height: document.documentElement.clientHeight
        }}
      >
        {/* {!displayButton && <div className={style.chapter902Icon} />} */}
        <div className={style.itemBox}>
          {/* <div className={style.xpIconBox} /> */}
          <p className={style.ordinaryText}>
            <span className={style.blueBigText}>
              全国337个
              <br />
              地级市全覆盖
            </span>
            北至漠河，南到三沙；西抵喀什，东达鸡西
            <br />
            小鹏超充累计上线
            <span className={style.blueNormalText}>{brandTotal}</span>
            座品牌站
            <br />
            {status === 2 && (
              <span style={{ marginBottom: 0 }}>你的城市已上线</span>
            )}
            {status === 2 && (
              <span className={style.blueNormalText}>
                {brandCityTotal || '--'}座
              </span>
            )}
            {status === 2 && '小鹏品牌站'}
          </p>
          <br />
          <p className={style.grayNormalText}>无论去往何方，我们伴你无忧畅行</p>
        </div>
        <div className={style.chapter9Icon} />
        {displayButton && (
          <div className={style.getMyChargeLevel} onClick={setPoster}>
            <p className={style.chargeLevelText}>点击生成你的充电等级</p>
          </div>
        )}
      </div>
    );
  }
}

export default Chapter9;
